function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import ThemeContext from '../Context';
var withTheme = function withTheme(WrappedComponent) {
  function HOC(props) {
    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (value) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, value, props));
    });
  }
  HOC.displayName = WrappedComponent.displayName || 'withTheme';
  return HOC;
};
export default withTheme;